// @flow
import type { AuthViewer } from 'app/packages/pinterest-flow-types/viewer';
import type { Pin } from 'app/common/react/components/closeup/types';
import { shouldShowPromoteButtonToPinner } from 'app/common/react/components/closeup/CloseupBody/utils';

type ShouldShowBetterSaveArgs = {|
  boardCount?: number,
  pin: Pin,
  viewer: AuthViewer,
|};

export default ({ viewer, pin, boardCount }: ShouldShowBetterSaveArgs): boolean => {
  if (pin.content_sensitivity && pin.content_sensitivity.is_sensitive_content) {
    return false;
  } else {
    return (
      !shouldShowPromoteButtonToPinner({
        viewer,
        pin,
      }) &&
      typeof boardCount !== 'undefined' &&
      boardCount >= 2
    );
  }
};
